import { flag } from "components/providers/featureFlags/flagUtils";

export type FeatureFlags = typeof featureFlags;
export type FeatureFlagsWidened = Record<
    string,
    ReturnType<(typeof flag)[keyof typeof flag]>
>;

export const featureFlags = {
    "Team Scoring": flag.boolean(false), // Starts wth false to prevent redirects on page reload
    Restrictions: flag.boolean(true),
};
